import AkButton from '@atlaskit/button/standard-button';
import { ButtonClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { pluralize } from '@atlassian/mpac-utils';
import React from 'react';
import { ANALYTICS_SUBJECT_ID_APP_REQUEST_COMMENTS_CANCEL, ANALYTICS_SUBJECT_ID_APP_REQUEST_COMMENTS_VIEW_APP_DETAILS, ANALYTICS_SUBJECT_ID_MANAGE_APP_REQUESTS } from '../../../../../analytics/Events';
import { ANALYTICS_MODAL_APP_REQUEST_COMMENTS_MODAL } from '../../../../../analytics/Sources';
import ModalDialog from '../../../../common/ModalDialog';
import { useAppRequestComments } from '../hooks';
import AppRequestCommentsTable from './AppRequestCommentsTable';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const AppRequestCommentsModal = props => {
  const {
    comments,
    error,
    pending
  } = useAppRequestComments({
    productName: props.productName,
    cloudId: props.cloudId,
    appKey: props.appKey
  });
  const fireAnalyticsEvent = useAnalyticsEvents();
  const handleAnalyticsEvent = actionSubjectId => fireAnalyticsEvent({
    eventType: ButtonClickedEvent,
    actionSubjectId,
    objectType: ANALYTICS_SUBJECT_ID_MANAGE_APP_REQUESTS,
    objectId: props.appKey
  });
  const onCancelClick = () => {
    props.onClose();
    handleAnalyticsEvent(ANALYTICS_SUBJECT_ID_APP_REQUEST_COMMENTS_CANCEL);
  };
  const onViewAppDetailsClick = () => {
    handleAnalyticsEvent(ANALYTICS_SUBJECT_ID_APP_REQUEST_COMMENTS_VIEW_APP_DETAILS);
  };
  const footer = () => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AkButton, {
      appearance: "subtle",
      onClick: onCancelClick,
      children: "Cancel"
    }), /*#__PURE__*/_jsx(AkButton, {
      appearance: "primary",
      href: props.appDetailsLink,
      onClick: onViewAppDetailsClick,
      target: "_blank",
      children: "View app details"
    })]
  });
  const commentsText = !pending && !error ? " - ".concat(pluralize('comment', comments.length, true)) : '';
  return /*#__PURE__*/_jsx(ModalDialog, {
    analyticsName: ANALYTICS_MODAL_APP_REQUEST_COMMENTS_MODAL,
    onClose: props.onClose,
    heading: "".concat(props.appName).concat(commentsText),
    footer: footer(),
    shouldScrollInViewport: false,
    width: 800,
    children: /*#__PURE__*/_jsx(AppRequestCommentsTable, {
      comments: comments,
      error: error,
      pending: pending
    })
  });
};
export default AppRequestCommentsModal;